/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { clamp as r } from "../../core/mathUtils.js";
import { globalCss as t } from "./globalCss.js";
import { classes as o } from "./widgetUtils.js";
import { tsx as i } from "./jsxFactory.js";
function e({
  level: r,
  class: e,
  ...n
}, l) {
  const a = s(r);
  return i(`h${a}`, {
    ...n,
    "aria-level": String(a),
    class: o(t.heading, e),
    role: "heading"
  }, l);
}
function s(t) {
  return r(Math.ceil(t), 1, 6);
}
function n(r, t = 1) {
  return s(r + t);
}
export { e as Heading, n as incrementHeadingLevel };